// Navigation behaviour, rebuilt on load and on resize from the original markup.
//
// 1. Nested dropdowns (Porto-style): any nav item whose label begins with "-"
//    becomes a child of the preceding top-level item. A parent linking to "#"
//    acts purely as a dropdown toggle.
// 2. Overflow collapse (original Casper behaviour): trailing top-level items
//    that don't fit are tucked into a "•••" more-menu.
(function () {
    const mediaQuery = window.matchMedia('(max-width: 767px)');

    const head = document.querySelector('.gh-head');
    if (!head) return;
    const menu = head.querySelector('.gh-head-menu');
    const nav = menu && menu.querySelector('.nav');
    if (!nav) return;

    const navHTML = nav.innerHTML;
    const caretSVG = '<svg class="gh-submenu-caret" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" width="14" height="14"><path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"></path></svg>';
    const dotsSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor"><path d="M21.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM13.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM5.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0z"></path></svg>';

    let windowClickListener;

    function buildSubmenus() {
        const items = Array.prototype.slice.call(nav.children).filter(function (el) {
            return el.tagName === 'LI';
        });
        let parent = null;
        items.forEach(function (li) {
            const a = li.querySelector('a');
            const label = a ? a.textContent.trim() : '';
            if (label.charAt(0) === '-') {
                if (!parent) return;
                if (a) a.textContent = label.replace(/^[-\s]+/, '');
                let sub = parent.querySelector(':scope > .gh-submenu');
                if (!sub) {
                    sub = document.createElement('ul');
                    sub.className = 'gh-submenu';
                    parent.classList.add('gh-has-submenu');
                    const pa = parent.querySelector('a');
                    if (pa) {
                        pa.setAttribute('aria-haspopup', 'true');
                        pa.setAttribute('aria-expanded', 'false');
                        pa.insertAdjacentHTML('beforeend', caretSVG);
                        if (pa.getAttribute('href') === '#') {
                            pa.addEventListener('click', function (e) {
                                e.preventDefault();
                            });
                        }
                    }
                    parent.appendChild(sub);
                }
                sub.appendChild(li);
            } else {
                parent = li;
            }
        });

        // On touch / mobile, tapping a parent toggles its submenu.
        nav.querySelectorAll('.gh-has-submenu > a').forEach(function (a) {
            a.addEventListener('click', function (e) {
                if (!mediaQuery.matches) return;
                e.preventDefault();
                const li = a.parentNode;
                const open = li.classList.toggle('is-submenu-open');
                a.setAttribute('aria-expanded', String(open));
            });
        });
    }

    function collapseOverflow() {
        if (mediaQuery.matches) return;
        const submenuItems = [];

        while ((nav.offsetWidth + 64) > menu.offsetWidth) {
            if (nav.lastElementChild) {
                submenuItems.unshift(nav.lastElementChild);
                nav.lastElementChild.remove();
            } else {
                return;
            }
        }

        if (!submenuItems.length) return;

        const toggle = document.createElement('button');
        toggle.setAttribute('class', 'nav-more-toggle');
        toggle.setAttribute('aria-label', 'More');
        toggle.innerHTML = dotsSVG;

        const wrapper = document.createElement('div');
        wrapper.setAttribute('class', 'gh-dropdown');

        if (submenuItems.length >= 10) {
            document.body.classList.add('is-dropdown-mega');
            wrapper.style.gridTemplateRows = 'repeat(' + Math.ceil(submenuItems.length / 2) + ', 1fr)';
        } else {
            document.body.classList.remove('is-dropdown-mega');
        }

        submenuItems.forEach(function (child) {
            wrapper.appendChild(child);
        });

        toggle.appendChild(wrapper);
        nav.appendChild(toggle);

        toggle.addEventListener('click', function () {
            document.body.classList.toggle('is-dropdown-open');
        });

        windowClickListener = function (e) {
            if (!toggle.contains(e.target) && document.body.classList.contains('is-dropdown-open')) {
                document.body.classList.remove('is-dropdown-open');
            }
        };
        window.addEventListener('click', windowClickListener);
    }

    function render() {
        if (windowClickListener) {
            window.removeEventListener('click', windowClickListener);
            windowClickListener = null;
        }
        document.body.classList.remove('is-dropdown-open');
        nav.innerHTML = navHTML;

        try {
            buildSubmenus();
        } catch (e) {
            // Never let a nav-parsing edge case break the rest of the bundle.
        }
        collapseOverflow();
        document.body.classList.add('is-dropdown-loaded');

        if (mediaQuery.matches) {
            nav.querySelectorAll('li').forEach(function (item, index) {
                item.style.transitionDelay = 0.03 * (index + 1) + 's';
            });
        }
    }

    imagesLoaded(head, function () {
        render();
    });

    window.addEventListener('resize', function () {
        setTimeout(render, 1);
    });
})();
